import script from "./Category.vue?vue&type=script&setup=true&lang=js"
export * from "./Category.vue?vue&type=script&setup=true&lang=js"

import "./Category.vue?vue&type=style&index=0&id=17618215&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17618215"]])

export default __exports__